<script setup lang="ts">
import { RouterLink } from 'vue-router'
import { useAuthStore } from '../stores/auth'
import hangarApiLogo from '../../assets/svg/hangar-api-logo.svg?raw'
import CLoginButton from '../components/CLoginButton.vue';

const auth = useAuthStore()
</script>

<template>
	<main class="l-row l-stack">
		<template v-if="!auth.loading && !auth.user">
			<span v-html="hangarApiLogo" />
			<h1>Welcome to Hangar API</h1>
			<p>Please log in to continue.</p>
			<div><c-login-button/></div>
		</template>

		<template v-else-if="auth.user">
			<span v-html="hangarApiLogo" />
			<h1>Hello {{ auth.user.display_name }}!</h1>
			<p>Well, this is a bit of a work-in-progress. We're still adding features, but in the meantime, here are a few things you can currently do:</p>

			<div class="l-grid l-grid--3 l-grid--gap-1">
				<section class="c-panel l-stack--sm">
					<h2 class="u-h5">Browse Competitions</h2>
					<p>Check out our community-organized KSP BDA competitions</p>
					<div><RouterLink class="c-button" to="/competitions">Go</RouterLink></div>
				</section>

				<section class="c-panel l-stack--sm">
					<h2 class="u-h5">Start a new competition</h2>
					<p>Create your own competition</p>
					<div><RouterLink class="c-button" to="/competitions/new">Go</RouterLink></div>
				</section>

				<section class="c-panel l-stack--sm">
					<h2 class="u-h5">Change your display name</h2>
					<p>Or change other settings on your profile</p>
					<div><RouterLink class="c-button" to="/profile">Go</RouterLink></div>
				</section>
			</div>
		</template>
	</main>
</template>
